import NavigationBar from "components/modules/NavigataionBar";
import React from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Routes from "routes";
import { isPrint } from "utils/copy";


function App() {
    const [isMobile, setIsMobile] = React.useState(false);
    const [search, setSearch] = useSearchParams();
    const { pathname } = useLocation();

    const checkPathname = () => {
        if(pathname.includes('login') || pathname.includes('signup') || pathname.includes('forgot-password')) {
            return false;
        }

        return true;
    }

    const handleWindowResize = () => {
        setIsMobile(window.innerWidth < 1024);
    };

    React.useEffect(() => {
        const error = search.get('verifyError')
        if(error) {
            if (isPrint(error)) {
                toast.error(error);
             }
            search.delete('verifyError');
            setSearch(search)
        }

    // eslint-disable-next-line
    }, [])
    
    React.useEffect(() => {
        handleWindowResize();

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return (
        <div
            className="app_wrapper flex flex-col w-full"
        >
            {checkPathname() && <NavigationBar isMobile={isMobile} />}
            <Routes 
                isMobile={ isMobile }
            />
        </div>
    );
}

export default App;
